export const getFormattedData = (data) => {
  return data.map((dropYard) => {
    const { trailerInventory = [], tractorInventory = [], ...rest } = dropYard;
    return {
      ...rest,
      trailers: trailerInventory.reduce((acc, trailer) => {
        acc[trailer.trailerId] = trailer.eqptCount;
        return acc;
      }, {}),
      tractors: tractorInventory.reduce((acc, tractor) => {
        acc[tractor.tractorId] = tractor.eqptCount;
        return acc;
      }, {}),
    };
  });
};

export const getEquipmentsList = (data = []) => {
  const trailerMap = new Map();
  const tractorMap = new Map();

  data.forEach(({ trailerInventory = [], tractorInventory = [] }) => {
    trailerInventory.forEach(({ trailerId, trailerName }) => {
      if (!trailerMap.has(trailerId)) {
        trailerMap.set(trailerId, { id: trailerId, name: trailerName });
      }
    });

    tractorInventory.forEach(({ tractorId, tractorName }) => {
      if (!tractorMap.has(tractorId)) {
        tractorMap.set(tractorId, { id: tractorId, name: tractorName });
      }
    });
  });

  const trailers = Array.from(trailerMap.values());
  const tractors = Array.from(tractorMap.values());
  return { trailers, tractors };
};
